/**
 * creditErrorText — turn a caught error into a credit-aware inline message.
 *
 * The global CreditGuardHost already shows a refill modal + toast on any
 * insufficient-credits 402, but a call site's OWN inline text should not
 * contradict it (e.g. "erreur temporaire, réessayez" for an out-of-credits
 * case is misleading). Use this to render the honest credit message inline,
 * falling back to the site's normal message otherwise. The refill CTA comes
 * from the global modal, so the inline text just needs to name the real cause.
 */
import { isInsufficientCreditsError } from '@/components/InsufficientCreditsBanner';
import { tr } from '@/i18n';

export const INSUFFICIENT_CREDITS_TEXT =
  tr('shell.features.creditsCreditError.insufficientAiCreditsTopUpYour');

export function creditErrorText(err: unknown, fallback: string): string {
  return isInsufficientCreditsError(err) ? INSUFFICIENT_CREDITS_TEXT : fallback;
}

/** True when the error is an insufficient-credits 402 (re-exported for call sites). */
export { isInsufficientCreditsError } from '@/components/InsufficientCreditsBanner';
